import { removeConnectedNodes } from '@atlaskit/editor-common/utils';
import { createCommand } from '../plugin-factory';
export var removeDescendantNodes = function removeDescendantNodes(sourceNode) {
  return createCommand({
    type: 'UPDATE_STATE',
    data: {
      element: undefined
    }
  }, function (tr, state) {
    return sourceNode ? removeConnectedNodes(state, sourceNode) : tr;
  });
};